<section class="v-section">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <a routerLink="/accessories" [fragment]="category" class="black mt-3 mt-md-0"><i class="fa fa-long-arrow-left"
                        aria-hidden="true"></i></a>
            </div>
            <app-preloader *ngIf="isLoading"></app-preloader>
            <ng-template [ngIf]="addOn">
                <div class="col-md-4 col-xl-5 sm-0">
                    <div class="container mt-4">
                        <div class="row">
                            <div class="col-md-12">
                                <div id="custCarousel" class="carousel slide" data-ride="carousel" align="center">
                                    <!-- slides -->
                                    <div class="carousel-inner">
                                        <img [src]="addOn.image_1 | imagePath" />
                                        <div class="carousel-item" *ngIf="addOn.image_2">
                                            <img [src]="addOn.image_2 | imagePath" alt="img" class="img-fluid">
                                        </div>
                                    </div>
                                    <!-- Left right -->
                                    <a class="carousel-control-prev" href="#custCarousel" data-slide="prev">
                                        <span class="carousel-control-prev-icon"></span>
                                    </a>
                                    <a class="carousel-control-next" href="#custCarousel" data-slide="next">
                                        <span class="carousel-control-next-icon"></span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-8 col-xl-7">
                    <div class="row">
                        <div class="col-md-12 col-xl-12 col-12 f-details">
                           <div class="product-top">
                                <div class="col-md-12 col-lg-6 col-sm-12 col-xs-12">
                                    <h2 class="bold mb-2"> {{addOn?.vendor?.business_name}}</h2>
                                    <!-- <h5 class="mb-2"> {{addOn?.title}}</h5> -->
                                    <div class="increase-font2 d-flex flex-column">
                                        <span class="mb-2 fw-sb">{{addOn?.title}}</span>
                                        <span class="mb-0 fw-sb si-red">SKU : {{addOn?.part_number}}</span>
                                        
                                    </div>
                                </div>

                                <div
                                    class="col-md-12 col-lg-6 col-sm-12 col-xs-12 flex-column increase-font2 d-flex justify-content-between">
                                    <div class="product-top d-flex align-items-end flex-column">
                                        <div class="increase-font2">
                                            <span class="bold npc">MSRP:</span>
                                            <span class="ml-3 bold npc">{{ addOn?.price | currency:
                                                addOn?.vendor?.currency:'symbol' }}</span>
                                        </div>
                                        <div class="increase-font2 p-0 " *ngIf="discountedPrice && is_hide_cost == null">
                                            <span class="bold npc pb">Your Price:</span>
                                            <span class="ml-3 bold npc pb">{{ discountedPrice | currency:
                                                addOn?.vendor?.currency:'symbol'
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 d-flex  justify-content-between align-items-center mt-4 mb-3 border-tb pt-4 pb-4">

                            <div class="d-flex align-items-center col-md-6 f-details pl-0">
                                <div class="custom-label new-quantity-box">
                                    <div class="input-group custom-adder custom-adder-rw position-relative">
                                        <input type="button" value="-" class="button-minus"
                                            (click)="decrementQuantity()" [disabled]="quantity <= minQuantity">
                                        <input type="number" step="1" [min]="minQuantity" [value]="quantity"
                                            name="quantity" class="quantity-field">
                                        <input type="button" value="+" class="button-plus"
                                            (click)="incrementQuantity()">
                                        <label class="f-light">Quantity</label>
                                    </div>
                                </div>

                                <div class="">

                                    <div>
                                        <p class="mb-0 cp text-du pl-2 max-text" *ngIf="addOn.total_quantity>0" (click)="getAddonByAccessory(addOn.id)" data-toggle="modal" data-target="#stockModal">
                                            {{ addOn.total_quantity }} in stock</p>
                                        <p class="mb-0 pl-2" *ngIf="addOn.total_quantity<=0">
                                            - Out of stock</p>
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex align-items-center justify-content-end col-md-6 pr-0">


                                <!-- <button type="button" class="btn btn-02 f-large  addcart ml-3 new-btn" *ngIf="!(productCartTotalQty[product.product_variant_id] === undefined || productCartTotalQty[product.product_variant_id] <= 0)" (click)="onAddToCart(product)"> -->
                                <button type="button" *ngIf="addOn.total_quantity>0"
                                    class="btn btn-02 f-large  addcart  new-btn cart-btn text-uppercase"
                                    (click)="AddToCart(addOn.id, addOn?.total_quantity)">
                                    <span>ADD TO CART</span>
                                </button>
                            </div>


                        </div>
                        <div class="col-md-12 mb-3">
                            <div class="card">
                                <div class="card-header bg-black text-white" *ngIf="addOn.add_on_category_id == 1 || addOn.add_on_category_id == 6">
                                    Description
                                </div>
                                <div class="card-header bg-black text-white" *ngIf="addOn.add_on_category_id != 1 && addOn.add_on_category_id != 6">
                                    Specifications
                                </div>
                                <div class="card-body bg-grey">
                                    <div class="row new-font" style="font-weight: 500;" *ngIf="addOn.add_on_category_id == 1 || addOn.add_on_category_id == 6">
                                        <div class="col-md-12" *ngFor="let spec of specs">
                                            <div class="row p-1" *ngIf="addOn[spec]">
                                                <div class="col-md-12">{{ addOn[spec] }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row new-font m-0" style="font-weight: 500; background: white" *ngIf="addOn.add_on_category_id != 1 && addOn.add_on_category_id != 6">
    
                                        <div class="col-md-12 row-m-0 m-0 p-0"> 
                                            <div *ngFor="let spec of specs; let i = index">
                                                <!-- Open a new row for every even index -->
                                                <div class="row bg-grey" *ngIf="i % 2 === 0"  [style]="i < (specs.length - 2) ? 'margin-bottom: 3px !important' : ''">
                                                    <div class="col-md-6 d-flex">
                                                        {{convertToTitleCase(spec)}} : {{ addOn[spec] }}
                                                    </div>
                                                    <!-- Check if there's a next item to display in the second column -->
                                                    <div class="col-md-6 d-flex" *ngIf="specs[i + 1]">
                                                        {{convertToTitleCase(specs[i + 1])}} : {{ addOn[specs[i + 1]] }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                                                              
                                    </div>
                                    <!-- <div class="card-body bg-grey">
                                        <ul>
                                            <li ></li>
                                        </ul>
                                    </div> -->
                                </div>
                            </div>
                        </div>

                        <!-- <div class="col-6 col-md-6 col-lg-6 col-xl-6 mb-3 f-details"
                            *ngFor="let inventory of addOn?.addon_inventory">
                            <div class="grid-box" *ngIf="!inventory.eta">
                                <p class="mb-0">
                                    {{ inventory?.quantity }} in stock
                                </p>
                                <input autocomplete="off" type="number" step="1" min="0" name="quantity"
                                    class="search-inputs-bold input-details mr-2"
                                    [(ngModel)]="addOnQty[addOn.id + '_' + inventory.warehouse_id]"
                                    (ngModelChange)="addEditQty(inventory?.ware_house?.code, inventory?.ware_house?.id, inventory.quantity,  addOn.id, addOn?.addon_inventory, $event)" />
                            </div>
                            <div class="grid-box" *ngIf="inventory.eta">
                                <p class="mb-0" *ngIf="inventory.quantity>0">{{inventory?.ware_house?.warehouse_name}} -
                                    {{ inventory.quantity }} in stock</p>
                                <p class="mb-0" *ngIf="inventory.quantity<=0">{{inventory?.ware_house?.warehouse_name}}
                                    - Out of stock</p>
                                <input autocomplete="off" type="number" step="1" min="0" name="quantity"
                                    class="search-inputs-bold input-details mr-2"
                                    [(ngModel)]="addOnQty[addOn.id + '_' + inventory.warehouse_id]"
                                    (ngModelChange)="addEditQty(inventory?.ware_house?.code, inventory?.ware_house?.id, inventory.quantity,  addOn.id, addOn?.addon_inventory, $event, inventory.eta_qty)" />
                                <p class="mb-0 text-left">{{inventory .eta_qty}} pcs {{inventory .eta}}</p>
                            </div>
                        </div>

                        <div class="col-md-12 d-flex justify-content-end mb-3">
                            <button type="button" class="btn btn-02 f-large addcart ml-3 new-btn"
                                [disabled]="addOnCartTotalQty[addOn.id] === undefined || addOnCartTotalQty[addOn.id] <= 0"
                                (click)="onAddToCart(addOn.id, addOn?.addon_inventory)">
                                <span>ADD TO CART</span>
                            </button>
                        </div> -->
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</section>

<div class="modal fade stock-modal" id="stockModal" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h5 class="modal-title" id="exampleModalLabel">Inventory</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body border-0">
        <div class="d-flex flex-row align-items-center justify-content-center inventory_loader">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <span>&nbsp;&nbsp;Fetching Data ...</span>
        </div>
        <div class="table-responsive inventory_table">
          <table class="table cart-table">
              <thead>
              <tr>
                  <th>Warehouse</th>
                  <th>Quantity</th>
                  <th>Ship From</th>
              </tr>
              </thead>
              <tbody >
                  <tr *ngFor="let inventory of inventoryData; let i = index">
                    <td>{{inventory.warehouse_name}}</td>
                    <td>
                      <span *ngIf="inventory.quantity>0">{{ inventory.quantity }}</span>
                      <span *ngIf="inventory.quantity<=0">{{ inventory.eta_qty }}pcs ETA {{ inventory.eta}}</span>
                    </td>
                    <td>
                      <input type="radio" name="stock" [checked]="i === 0" (change)="setWarehouse(inventory.id)"/>
                    </td>
                  </tr>
              </tbody>
          </table>
          </div>

      </div>
    </div>
  </div>
</div>
